@use "../../styles/breakpoint.module.scss" as *;

.root {
    grid-column: content;
    column-gap: var(--spacer-32);
    display: grid;
    grid-template-columns: 1fr min-content 1fr;
    grid-template-areas: "img sep txt";
    margin-block: var(--spacer-40);

    & > [role="separator"] {
        grid-area: sep;
        height: 100%;

        --color: var(--color-contrast);

        @media ($below-mobile) {
            display: none;
        }
    }

    @media ($below-mobile) {
        grid-template-columns: 1fr;
        grid-template-areas:
            "img"
            "sep"
            "txt";
    }
}

.heroImage {
    grid-area: img;
    @media ($above-mobile) {
        overflow: hidden;
        height: 500px;

        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
            object-position: center;
        }
    }
}

.heroText {
    grid-area: txt;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: start;

    @media ($below-mobile) {
        margin-top: var(--spacer-24);
    }
}

.pill {
    composes: fontST14 from "../../styles/typography.module.scss";
    background: var(--red);
    color: var(--white);
    border-radius: var(--border-radius-sm);
    padding-inline: var(--spacer-8);
}

.distance {
    composes: fontST16 from "../../styles/typography.module.scss";
    margin-left: var(--spacer-16);
}

.title {
    composes: fontHB104 from "../../styles/typography.module.scss";
    margin-block: var(--spacer-24) var(--spacer-16);
}

.subtitle {
    flex-grow: 1;
    margin-bottom: var(--spacer-40);
}

.subtitleText {
    composes: fontHB40 from "../../styles/typography.module.scss";
}

.attendance {
    composes: fontST20 from "../../styles/typography.module.scss";
    column-gap: 8px;
    margin-bottom: var(--spacer-4);
}

.buttons {
    margin-top: var(--spacer-24);
    display: flex;
    gap: var(--spacer-24);
}
